<template>
  <div>
    <div class="schedule-header">
      <span class="title">Расписание PUSH-уведомлений для мобильного приложения</span>
    </div>
    <SpinnerLoading v-if="isLoading" color="blue" class="schedule-spinner" />
    <div v-else class="schedule-list">
      <div class="entries">
        <div
          v-for="(item, index) in schedules"
          :key="index"
          class="entry"
        >
          <div class="info">
            <div class="time">
              с {{ item.from }} по {{ item.to }}
            </div>
            <div class="days">
              {{ formatDays(item.days) }}
            </div>
          </div>
          <div class="actions">
            <button @click="deleteSchedule(index)">
              <svg class="icon">
                <use xlink:href="#icon-trash" />
              </svg>
            </button>
          </div>
        </div>
        <div v-if="!schedules.length && !showEditor" class="add-btn" @click="showEditor = true">
          <img src="@/assets/img/icons/icon-add.svg" class="icon-add-schedule">
          <span>Добавить расписание</span>
        </div>
        <ScheduleAnalytics
          v-if="showEditor"
          :analytic-type="analyticType"
          :camera-number="cameraNumber"
          @save="onScheduleSaved"
          @cancel="showEditor = false"
        />
      </div>
    </div>
  </div>
</template>


<script>
import ScheduleAnalytics from "@/components/pacs/analytics/schedule/ScheduleAnalytics.vue";
import {ACTION_DELETE_SCHEDULE, ACTION_LOAD_SCHEDULES_LIST, DAYS_OF_WEEK} from "@/store/analytics/schedules/index.js";

/**
 *  Компонент отображения списка расписаний
 *
 **/

export default {
  name: 'ScheduleList',
  components: {
    ScheduleAnalytics,
  },
  props: {
    analyticType: {
      type: String,
    },
    cameraNumber: {
      type: String,
    },
  },
  data() {
    return {
      schedules: [],
      scheduleId: '',
      isLoading: false,
      showEditor: false,
    };
  },
  created() {
    this.loadSchedules();
  },
  methods: {
    async onScheduleSaved() {
      this.showEditor = false;
      await this.loadSchedules();
    },
    mapSchedules(apiResponse) {
      return apiResponse.map(schedule => {
        const firstSetting = schedule.settings[0];
        const days = schedule.settings
          .filter(setting => setting.is_active)
          .map(setting => {
            const day = DAYS_OF_WEEK.find(d => d.value === setting.day_of_week);
            return day ? day.label : '';
          })
          .filter(label => label !== '');
        return {
          from: firstSetting?.start_time?.slice(0,5) || "00:00",
          to: firstSetting?.end_time?.slice(0,5) || "00:00",
          days: days,
          scheduleId: schedule.schedule_id,
        };

      });
    },

    async loadSchedules(){
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch(`analytics/schedules/${ACTION_LOAD_SCHEDULES_LIST}`,
                                                    [this.cameraNumber, this.analyticType]);
        this.schedules = this.mapSchedules(response);
      } finally {
        this.isLoading = false;
      }
    },
    formatDays(days) {
      return days.join(', ');
    },
    async deleteSchedule() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(`analytics/schedules/${ACTION_DELETE_SCHEDULE}`,
                                   [this.schedules[0].scheduleId]);
      } finally {
        this.isLoading = false;
        await   this.loadSchedules();
      }
    },

    // editSchedule(index) {
    //   const item = this.schedules[index];
    //   this.$camsdals.open(
    //     ScheduleAnalytics,
    //     {
    //       from: item.from,
    //       to: item.to,
    //       days: item.days,
    //     },
    //
    //     {dialogTitle: 'Редактировать расписание'},
    //     {
    //       closeOnBackdrop: true,
    //       size: "vuedal-auto-width",
    //       name: "js-click-outside",
    //     }
    //   ).then(result => {
    //     if (result) {
    //       this.schedules.splice(index, 1, result);
    //     }
    //   });
    // },
  },
};
</script>

<style scoped>
.schedule-spinner {
  margin-top: 70px;
}
.schedule-list {
  font-family: Arial, sans-serif;
  padding: 12px;
  width: 100%;
  max-width: 400px;
}

.schedule-header {
  text-align: center;
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #e6e6e6;
  padding-bottom: 12px;
  padding-top: 12px;
}

.title {
  font-size: 15px;
  font-weight: bold;
  margin: 4px;
}
.entries {
}

.entry {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.info .time {
  font-size: 15px;
  margin-bottom: 4px;
}

.info .days {
  font-size: 12px;
  color: #555;
  margin-right: 150px;
}

.actions {
  display: flex;
  gap: 8px;
}

.actions button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.icon {
  fill: #444;
  width: 23px;
  height: 22px;
}

.add-btn {
  display: flex;
  align-items: center;
  margin-top: 16px;
  color: #2f80ed;
  cursor: pointer;
  font-size: 15px;
  justify-content: center;
}

.icon-add-schedule {
  width: 15px;
  height: 15px;
  fill: #2f80ed;
  margin-right: 8px;
}
</style>
